import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import collectPreviewTargets from './collectLinks';
import { mountCard, removeCardsWithin, sweepDetachedCards, unmountCardsWithin } from './cardRegistry';
export default function watchContent(component, bodies) {
  const target = typeof component === 'string' ? component : component.prototype;
  extend(target, ['oncreate', 'onupdate'], function (_) {
    sweepDetachedCards();
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    for (const body of bodies.call(this, args[0])) {
      if (previewsHidden()) {
        removeCardsWithin(body);
      } else {
        collectPreviewTargets(body).forEach(mountCard);
      }
    }
  });
  extend(target, 'onremove', function (_) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    topLevelElements(args[0]).forEach(unmountCardsWithin);
  });
}
export function bodiesMatching(selector) {
  return function (vnode) {
    return topLevelElements(vnode).flatMap(element => [...(element.matches(selector) ? [element] : []), ...Array.from(element.querySelectorAll(selector))]);
  };
}
export function topLevelElements(vnode) {
  const elements = [];
  let node = vnode.dom;
  for (let i = 0; node && i < (vnode.domSize ?? 1); i++, node = node.nextSibling) {
    if (node instanceof HTMLElement) elements.push(node);
  }
  return elements;
}
function previewsHidden() {
  return Boolean(app.session.user?.preferences()?.hideLinkPreviews);
}
flarum.reg.add('datlechin-link-preview', 'forum/utils/watchContent', watchContent);